import { lazy } from 'react';

const ProActivatedPage = lazy(() => import('./ProActivatedPage'));

const ProActivatedConfig = {
  settings: {
    layout: {
      config: {
        topBanner: {
          display: false,
        },
        healtheraHeader: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: 'pro-activated',
      element: <ProActivatedPage />,
    },
  ],
};

export default ProActivatedConfig;
